import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { ApiService } from '@angular/synthrone-design/services';
import { ConfirmationComponent } from '@angular/synthrone-design/components';
import { AddUpdateFontFormComponent } from '@synthroneApp/components/forms/add-update-font-form/add-update-font-form.component';
import { OrganizationFontVariantsViewComponent } from '@synthroneApp/components/views/organization-font-variants-view/organization-font-variants-view.component';
import { ClientServiceSDK } from 'ms-client-angular-sdk';

@Component({
  selector: 'app-organization-fonts-view',
  templateUrl: './organization-fonts-view.component.html',
  styleUrls: ['./organization-fonts-view.component.scss']
})
export class OrganizationFontsViewComponent implements OnInit {

@ViewChild('fontsTable') fontsTable;
  
  configColumns = {
    family: {
      label: 'Name',
      sortable: false,
      truncate: true
    }
  };

  OrganizationFontVariantsViewComponent: any = OrganizationFontVariantsViewComponent;
  clients: Array<{
    name: string,
    planet: string
  }> = [];

  constructor(
    protected api: ApiService, 
    protected dialog: MatDialog,
    private clientService: ClientServiceSDK,
  ) { }

  ngOnInit() {
    this.clientService.clientsGet().subscribe((clients) => {
      this.clients = clients.map((client) => {
        return {
          name: client.name,
          planet: client.planet
        };
      });
    });
  }

  refreshTable = (): void => {
      this.fontsTable.getData()
  };

  deleteRow = (row: any): void => {
    this.dialog.open(ConfirmationComponent, {
      data: {
        message: `Are you sure you want to remove the <b>${row.family}</b> font family? <br>Removal is irreversible.`
      }
    }).afterClosed().subscribe((response) => {
      if (response == "proceed") {
        const params: any = {
            id: row.id,
        };
        this.api.makeRequest('api_system_fonts_delete', params, 'crafter').subscribe(() => {
          this.refreshTable();
        });
      }
    });
  };

  editRow = (row: any): void => {
    this.dialog.open(AddUpdateFontFormComponent, {
        height: '285px',
        width: '800px',
        data: {
            dataId: row.id,
            oldName: row.family,
            clients: this.clients,
            fontClients: row.clients,
            callback: (newName: string, fontClients: Array<string>) => {
                const params: any = {
                    id: row.id,
                    jsonPayload: {
                      family: newName,
                      clients: fontClients
                    }
                };
                return this.api.makeRequest('api_system_fonts_update', params, 'crafter');
            }
        },
        panelClass: 'no-padding-container'
    }).afterClosed().subscribe((response) => {
        if (response === true) {
            this.refreshTable();
        }
    });
  }

  sdClient = (): Observable<any> => {
      return this.api.makeRequest('api_system_fonts_list', {}, 'crafter');
  }

  addFontFamily = (): void => {
    this.dialog.open(AddUpdateFontFormComponent, {
        height: '285px',
        width: '800px',
        data: {
            oldName: '',
            clients: this.clients,
            fontClients: [],
            callback: (newName: string, fontClients: Array<string>) => {
                const params: any = {
                  family: newName,
                  clients: fontClients
                };
                return this.api.makeRequest('api_system_fonts_create', params, 'crafter');
            }
        },
        panelClass: 'no-padding-container'
    }).afterClosed().subscribe((response) => {
        if (response === true) {
            this.refreshTable();
        }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/views/organization-fonts-view/organization-fonts-view.component.ts